// extracted by mini-css-extract-plugin
export var disabled = "Clickable-module--disabled--ebc8e";
export var root = "Clickable-module--root--f3e4f";